import React,{useState, useEffect}  from 'react';
import {Card} from 'react-bootstrap'
import Sides from '../Bars/Diffjvscs';

import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Jscifelse(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  


return(
    <div>
 <Sides/>
      <Helmet>
 
 <title>Difference Between Java and C# ifelse tutorial For Beginners</title>
<meta name="description" content="Difference Between Java and C# ifelse tutorial for beginners.CodeExampler provides Multiple Programming Examples for Beginners,CodeExampler provides Free Online Tutorials for beginners and  questions of all technology like java tutorial, java tutorial,c# tutorial for beginners in deeply knowledge With Deeply" />
<meta name="keywords" content="codeexampler,programming language,ifelse,tutorial for begineers,Difference Between Java and Csharp(C#),Difference between program and code,java tutorial for begineers,C# tutorial for begineers,java tutorial for begineers,code,exampler,which online website to learn code,Difference Between Java and C# ,java vs Csharp ifelse,java vs Python," />
<link rel="canonical" href="https://www.codeexampler.com/java-vs-csharp-if-else" />
</Helmet>

<div className='lg:pl-56'>

    <h1 className="m-4 mh1">Java vs C# if-else</h1>
    <div className="first">
        <a href="/java-vs-csharp-if">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/java-vs-csharp-switch">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    <p className="mt-3 para">when if the condition is true so on that time target of the will be executed
     but if the condition is false so if it exists and the target of the else will be executed</p>

    <h2 className="mt-4 mh2">
Java if else syntax :</h2>
   
    <Card className='inde' border='primary m-4'>
  <Card.Header as="h5">Java if else statement syntax :</Card.Header>
  <Card.Body>
    <Card.Text>
   <p> If (condition)<br/>
    &#123;<br/>
Statement;<br/>
&#125;<br/>
Else<br/>
&#123;<br/>
Statement;<br/>
&#125;<br/>
</p>
    </Card.Text>
  </Card.Body>
</Card>

<h2 className="mt-4 mh2">
C# if else syntax :</h2>

<Card className='inde' border='primary m-4'>
  <Card.Header as="h5">if-else syntax in c#</Card.Header>
  <Card.Body>
    <Card.Text>
    <p>namespace(if else)<br/>
    &#123;<br/>
        If (condition)<br/>
        &#123;<br/>
Statement;<br/>
&#125;<br/>
Else<br/>
&#123;<br/>
Statement;<br/>
&#125;<br/>
&#125;
</p>
    </Card.Text>
  </Card.Body>
</Card>

<h3 className="mt-4">if-else Example in java</h3>


<Card className='inde' border='primary m-4'>
  <Card.Header as="h5">Q-Write a program to input a number and check this value is greater in Java if-else Statement Example?</Card.Header>
  <Card.Body>
  
    <Card.Text>
   <p>public class ifelse_example &#47;&#47; class is a keyword<br/>
   &#123;<br/>
   public static void main(String[] args) <br/>
&#123;<br/>
int a,b;<br/>
a=100;b=200;<br/>
if(a&#62;b)<br/>
&#123;<br/>
System.out.println("a is greater than b");<br/>
&#125;<br/>
else<br/>
&#123;<br/>
System.out.println("b is greater than a");<br/>
&#125;<br/>
&#125;<br/>
&#125;<br/>
</p>
    </Card.Text>
  </Card.Body>
  <Card.Footer>Output-<br/> b is greater than a</Card.Footer>
</Card>

<h3 className="mt-4">if-else Example in c#</h3>

<Card className='inde' border='primary m-4'>
  <Card.Header as="h5">Q- Write a program to input a number and check this value is greater than 1000 or not in the c# tutorial?
</Card.Header>
  <Card.Body>
    <Card.Text>
    <p>
    namespace if_else<br/>
    &#123;<br/>
    class Program<br/>
    &#123;<br/>
        static void Main(string[] args)<br/>
 &#123;<br/>
 int a;<br/>
    Console.WriteLine("enter a no");<br/>
  a = Convert.ToInt32(Console.ReadLine());<br/>
  if (a &#62; 1000)<br/>
  &#123;<br/>
     Console.WriteLine("a is greater than 1000");<br/>
     &#125;<br/>
     else<br/>
     &#123;<br/><br/>
  Console.WriteLine("a is less than 1000");<br/>
  &#125;<br/>
  &#125;<br/>
  &#125;<br/>
  &#125;
</p>
    </Card.Text>
  </Card.Body>
  <Card.Footer>Output-<br/>enter a no<br/>500<br/><br/>Answer-<br/>a is less than 1000</Card.Footer>
</Card>

<h1 className="mt-5">  </h1>
<div className="back">
        <a href="/java-vs-csharp-if">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/java-vs-csharp-switch">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    </div>
    </div>
)

}
export default Jscifelse;